<app-loader [isLoading]="isLoading"></app-loader>
<div class="container">
    <div class="box">
        <div class="firstBox">
            <div>
                <span class="title-small title">Ritwiki account</span>
            </div>

            <div class="money-box">
                <div class="fullName">
                    <span class="common-inter">{{ritwickName}}</span>
                </div>
                <div class="balance">
                    <span class="amount">
                        &#8377;{{ displayBalance.toLocaleString('en-IN', { minimumFractionDigits: 2,
                        maximumFractionDigits: 2 }) }}
                    </span>
                    <span class="common-inter acc-blnce">Acc. Balance</span>
                </div>
                <div class="button-div">
                    <!-- <button class="dp-secondary-btn" (click)="slideFromRight()">Prev. requests</button> -->
                    <!-- @if(currentBalanceInRitwikiAccount) -->
                    @if(isBankDetails){
                    <button class="dp-primary-btn btn" (click)="onDialogOpen()">Withdraw funds</button>
                    <button class="dp-secondary-btn second-btn" (click)="getAccountDetails('view')">View Bank
                        Details</button>
                    }@else{
                    <button class="dp-secondary-btn second-btn" (click)="getAccountDetails('add')">Add Bank
                        Account</button>
                    }
                </div>
            </div>
        </div>

        <div class="details">
            <div class="header-detail">
                <span class="activity">Previous requests</span>
                <span class="common-inter golden-text" (click)="vewAllTxns()">View all requests</span>
            </div>
            <div class="all-txns">
                @if(recentActivity.length>0){
                @for(txns of recentActivity; track txns ; let index = $index ){
                <div class="txnsArr">
                    <div class="header-detail">
                        <div class="dt-and-txnsType">
                            <span class="common-inter">{{txns.statusDesc}}</span>
                            <span class="common-inter txn-dt"> {{txns.appliedOn | date:'dd MMM yyyy'}}</span>
                        </div>
                        <div class="amount2">
                            <span class="common-inter"
                                [ngClass]="{'text-rejected':txns.statusId===85,'text-inProgress':txns.statusId===84}">{{txns.amount}}</span>
                        </div>
                    </div>
                    @if(index !== recentActivity.length -1 ){
                    <hr>
                    }
                </div>
                }
                } @else{
                <div style="text-align: center;padding: 40px 40px;">
                    <span class="no-data">No data found !</span>
                </div>
                }
            </div>
        </div>
    </div>
</div>

<app-ritwiki-right-slider [isVisible]="isRightSlideVisible" (closed)="slideFromRight()"></app-ritwiki-right-slider>